/**
 * Fire-and-forget product telemetry. PII-free by construction: no ids, no
 * cookies, nothing stored client-side; events carry a name, a level id, a
 * number and a short string. sendBeacon so a closing tab still delivers.
 */
const ENDPOINT = '/api/t';

// Agent sessions (?agent=1) run with telemetry off: the dashboards are
// about humans, and a tool-driven session would pollute every funnel.
let enabled = true;
export function setTelemetryEnabled(on) { enabled = on; }

export function track(event, { level = '', value = 0, meta = '' } = {}) {
  if (!enabled) return;
  try {
    const body = JSON.stringify({ e: event, l: level, v: value, m: String(meta).slice(0, 96) });
    if (navigator.sendBeacon?.(ENDPOINT, new Blob([body], { type: 'application/json' }))) return;
    fetch(ENDPOINT, { method: 'POST', body, keepalive: true }).catch(() => {});
  } catch { /* telemetry must never break play */ }
}

/** Uncaught errors are the telemetry that pays rent. The version rides in
 *  the meta so a spike is attributable: new regression or old cached build. */
export function wireErrorReporting(version = '') {
  const v = version ? ` v${version}` : '';
  window.addEventListener('error', (e) => {
    track('client_error', { meta: `${e.message ?? 'error'} @${e.filename?.split('/').pop() ?? ''}:${e.lineno ?? 0}${v}` });
  });
  window.addEventListener('unhandledrejection', (e) => {
    track('client_error', { meta: `rejection: ${String(e.reason?.message ?? e.reason).slice(0, 80)}${v}` });
  });
}
